// Re-export the new modular component
import HotelOCRResults from '@features/ocr/index';

export default HotelOCRResults;
